<template>
	<div />
</template>

<script>
export default {
	name: "Error",
	created() {
		console.error("Data quality score ms loaded without a start route.");
	}
};
</script>
